/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class BarsParser {

    static parseLaunch(launcherConfig) {
        return {
            operator: launcherConfig.operator,
            provider: launcherConfig.provider,
            timestamp: `?t=${launcherConfig.cacheBust}`,
            feedUrl: launcherConfig.feed,
            cdn: launcherConfig.cdn,
            gameProvider: launcherConfig.gameProvider,
            realityCheck: {}
        };
    }

    static parse(cfg, settings, options) {
        const config = cfg.bridge.realityCheck || {};
        const lobbyUrl = options.urlParams['lobbyURL'] || options.urlParams['lobbyUrl'] || options.urlParams['lobbyurl'] || options.urlParams['realityCheckLobbyUrl'];
        const depositUrl = options.urlParams['depositUrl'] || options.urlParams['depositURL'] || options.urlParams['depositurl'];
        const historyUrl = options.urlParams['historyUrl'] || options.urlParams['historyURL'] || options.urlParams['historyurl'] || options.urlParams['realityCheckHistoryUrl'];

        cfg.bridge.hasSkip = true;
        cfg.bridge.hasAnimationSkip = true;
        cfg.bridge.hasErrorTracking = !cfg.bundle && (options.urlParams['hasErrorTracking'] === 'true' || !options.isDevEnvironment);

        cfg.bridge.realityCheck = {
            minutes: parseFloat(options.urlParams['realityCheckMinutes']) || 0,
            elapsedMinutes: parseFloat(options.urlParams['realityCheckElapsedMinutes']) || 0,
            lobbyUrl,
            depositUrl,
            historyUrl,
            ...config
        };

        cfg.bridge.userActivity = {
            enabled: false,
            minutes: 20,
        };

        cfg.bridge.userActivity = {
            enabled: false,
            minutes: 20,
        };

        if (!cfg.bridge.localizationsPath) {
            cfg.bridge.localizationsPath = `${cfg.game.preconfig.cdn}../../localizations/`;
        }

        return cfg.bridge;
    }


}


module.exports = BarsParser;
